import { inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first, tap } from 'rxjs';
import { selectDocuments } from './document.selectors';
import { fetchDocuments } from './document.actions';

export const documentResolver = () => {
  const store = inject(Store);
  return store.pipe(
    select(selectDocuments),
    tap((documents) => {
      if (!documents || documents.length === 0) {
        store.dispatch(fetchDocuments());
      }
    }),
    first()
  );
};
